<template>
  <div class="product-item">
    <a
      class="product-item__link"
      :href="$contentful.service.transformSlugToLink(item.slug)"
      @click.prevent="navigateTo($contentful.service.transformSlugToLink(item.slug))"
    >
      <div class="product-item__img-wrapper">
        <img :src="getImg" :alt="item.imgAlt" class="product-item__img" />
        <div v-if="showDate && eventDate" class="product-item__date">
          {{ eventDate }}
        </div>
      </div>
      <h4 class="text-product-name product-item__title">
        <span v-html="$truncate(item.title, 55)" />
      </h4>
      <span
        v-if="showSubtitle && item.subtitle"
        class="text-link text-link--inline product-item__category"
      >
        {{ item.subtitle }}
      </span>
      <a
        v-else
        :href="$contentful.service.transformSlugToLink(item.parent.slug)"
        class="text-link text-link--inline product-item__category"
        @click.prevent.stop="navigateTo($contentful.service.transformSlugToLink(item.parent.slug))"
        v-html="item.parent.title"
      />
    </a>
  </div>
</template>
<script>
import { convertDateToItsZone } from '@/lib/utils/dates'

import navigationMixin from '@/components/common/mixins/navigationMixin'

export default {
  name: 'ProductItem',
  mixins: [navigationMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    showDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSubtitle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    eventDate() {
      if (this.item?.date && this.item?.additionalDate) {
        const startMonth = convertDateToItsZone(this.item.date, 'M')
        const endMonth = convertDateToItsZone(this.item.additionalDate, 'M')
        const formatDate = startMonth === endMonth ? 'D' : 'MMMM D'
        return `${convertDateToItsZone(this.item?.date, 'MMMM D')} - ${convertDateToItsZone(
          this.item.additionalDate,
          formatDate,
        )}`
      } else if (this.item?.date) {
        return `${convertDateToItsZone(this.item?.date, 'MMMM D')}`
      } else {
        return null
      }
    },
    getImg() {
      return this.item.thumbnailImg &&
        this.$contentful.service.getProductDefaultImage() === this.item.img
        ? this.item.thumbnailImg
        : this.item.img
    },
  },
}
</script>
